<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v9aRCy/tc-custom/9781455601950.jpg?1728851645850" alt="This image is the cover for the book Cavalry Battle That Saved the Union"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cavalry Battle That Saved the Union
      </h1>
      <p class="bookDescription body article font2">
        <p>Civil War historians have long been puzzled by Pickett’s seemingly suicidal frontal attack on the Union center at Gettysburg. </p><p> Here, for the first time, Paul D. Walker reveals Robert E. Lee’s true plan for victory at Gettysburg: a simultaneous strike against the Union center from the front and rear—Pickett’s infantry to charge the front, while Stuart’s cavalry struck the rear. The frontal assault by Pickett went off as scheduled, but as Stuart’s forces approached from the rear, they encountered a Union cavalry contingent. As the forces joined, the Union cavalry leader was quickly killed, and command fell to one of the most dynamic figures in American history—George Armstrong Custer. </p><p> What followed was America’s greatest cavalry battle: 7,500 Confederate horsemen ranged against 5,000 Union cavalry, Jeb Stuart against George Custer, with the outcome of the Civil War at stake. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul D. Walker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?080eaeb2